module.exports = __webpack_public_path__ + "static/media/bluetooth.a80476ac.png";